<template>
  <div class="images-list">
    <van-image
      v-for="(image, index) in images"
      :key="index"
      :src="image.url"
      lazy-load
    />
  </div>
</template>

<script>
  export default {
    name: 'DetailImages',
    props: {
      images: Array,
    },
  };
</script>

<style lang="scss" scoped>
/* 详情页图片列表 */
.images-list {
  display: flex;
  flex-direction: column;
}

.images-list .van-image {
  width: 100%;
}
</style>
